export const hasCompleteInsuranceDetails = (input) => Boolean(input.payerId?.trim() &&
    input.planMemberIdentifier?.trim() &&
    input.coordinationOfBenefitsType &&
    (input.beneficiaryIsSubscriber === true ||
        (input.beneficiaryIsSubscriber === false &&
            (input.subscriberId || input.subscriberRef))));
//# sourceMappingURL=hasCompleteInsuranceDetails.js.map